import { Middleware } from '@reduxjs/toolkit'
import { setQuickOrderData } from '../reducer/orders.reducer'
import { prepareQuickTradeOpenPayload } from '../util/quickTradePreferences'

export const quickTradePreferencesMiddleware: Middleware = () => (next) => (action) => {
    if (setQuickOrderData.match(action) && action.payload.openDialog === true) {
        return next({
            ...action,
            payload: prepareQuickTradeOpenPayload(action.payload),
        })
    }
    return next(action)
}
